var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('model-viewer',{ref:"modelV",staticClass:"embed",attrs:{"id":"modelV","preload":"","ar":"","src":"/static/lower.glb","ios-src":"/static/lower.usdz","camera-controls":"","background-color":"#fff"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e8711e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Viewer.vue
// module id = null
// module chunks = 